import { ColumnDef } from '@tanstack/react-table';
import Sorting from '@/components/Table/sorting';
import { NameCell } from '@/components/Table/Cell/NameCell';
import { IClaim } from '@/pages/main/types';

import { SwitchCell } from '@/components/Table/Cell/SwtichCell';
import { useEffect, useMemo } from 'react';
import DateCell from '@/components/Table/Cell/DateCell';
import StartCell from '@/components/Table/Cell/StartCell';
import RetSkyldnerCell from '@/components/Table/Cell/RetSkyldnerCell';
import NumberCell from '@/components/Table/Cell/NumberCell';
import { fetchClaims } from '@/store/slices/claimsSlice';
import { useAppDispatch } from '@/store/store';

interface IUseIsProcess {
  claims: IClaim[];
  isProcess: boolean;
}

export const useIsProcess = ({ claims, isProcess }: IUseIsProcess) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchClaims());
  }, [dispatch]);

  const columns: ColumnDef<IClaim>[] = useMemo(() => {
    return !isProcess
      ? [
          {
            accessorKey: 'debtorName',
            header: ({ column }) => (
              <Sorting header="Skyldner" column={column} />
            ),
            enableSorting: true,
            size: 340,
            cell: ({ row }) => <NameCell name={row?.original?.debtor?.name} />,
          },
          {
            accessorKey: 'dueDate',
            header: ({ column }) => (
              <Sorting header="Forfaldsdato" column={column} />
            ),
            enableSorting: true,
            minSize: 250,
            cell: ({ row }) => <DateCell date={row?.original?.dueDate} />,
          },
          {
            accessorKey: 'amountDue',
            minSize: 250,
            header: ({ column }) => (
              <Sorting header="Tilgodehavende" column={column} />
            ),
            cell: ({ row }) => <NumberCell number={row?.original?.amountDue} />,
          },
          {
            accessorKey: 'retskyldner',
            header: '',
            cell: ({ row }) => (
              <RetSkyldnerCell
                id={row?.original?.id}
                debtor={row?.original?.debtor}
              />
            ),
          },
        ]
      : [
          {
            accessorKey: 'objection',
            header: 'Uenighed',
            minSize: 220,
            Maxsize: 250,
            cell: ({ row }) => (
              <SwitchCell
                id={row?.original?.id}
                objection={row?.original?.objection}
                disabled={row?.original?.hasReminderResponse}
              />
            ),
          },
          {
            accessorKey: 'debtorName',
            header: ({ column }) => (
              <Sorting header="Skyldner" column={column} />
            ),
            enableSorting: true,
            minSize: 250,
            Maxsize: 320,
            cell: ({ row }) => <NameCell name={row?.original?.debtor?.name} />,
          },
          {
            accessorKey: 'dueDate',
            header: ({ column }) => (
              <Sorting header="Forfaldsdato" column={column} />
            ),
            enableSorting: true,
            cell: ({ row }) => <DateCell date={row?.original?.dueDate} />,
          },
          {
            accessorKey: 'amountDue',
            header: ({ column }) => (
              <Sorting header="Tilgodehavende" column={column} />
            ),
            enableSorting: true,
            Maxsize: 200,
            cell: ({ row }) => <NumberCell number={row?.original?.amountDue} />,
          },
          {
            accessorKey: 'start',
            header: '',
            cell: ({ row }) => (
              <StartCell
                id={row?.original?.id}
                debtorId={row?.original?.debtor?.id}
              />
            ),
          },
        ];
  }, [isProcess]);

  const claimsData = claims.filter(
    (claim: IClaim) => claim.isMissingInformation !== isProcess
  );

  return { claimsData, columns };
};
